import {hasPermission, isCredo} from 'common/HelperFunctions'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

/**
 * Reactive form of `isNewExamManagerEnabled` for components — route tables
 * especially. The plain helper reads the store imperatively, so a component
 * calling it renders once with whatever the store held at that moment; on a
 * prod hard-load that moment is BEFORE GET /general-settings resolves, and a
 * route table gated on the stale read would leave the legacy iframe owning
 * /institute/exam/* for an opted-in tenant.
 *
 * Selects the derived boolean, not the settings object: the reducer replaces
 * `generalSettings` with a fresh object on every refetch (settings saves,
 * several screen mounts), and the route tables should re-render only when the
 * flag actually flips.
 */
export const useIsNewExamManagerEnabled = (): boolean => {
  const settingOn = useSelector<RootState, boolean>(
    ({mainReducer}) => Number(mainReducer.generalSettings?.new_exam_manager) === 1
  )
  // Dev follows the setting like everywhere else, and Credo is on regardless
  // of it — see the note on `isNewExamManagerEnabled`, which this mirrors.
  return (isCredo() || settingOn) && hasPermission('exam_manager')
}
